<div class="container-fluid">

  <div class="card mb-1 mt-1">
    <div class="card-body">
      <app-com-sem-regra-filtro #filtroComponent titulo="Carteiras: Com regras" (onSearch)="pesquisar($event)"
                                (searchEvent)="searchEvent($event)" [cardType]="CardType.COM_REGRAS"></app-com-sem-regra-filtro>
    </div>
  </div>
  <app-total-table [showRegistersPerPage]="false" [totalRegistros]="totalRegistros"></app-total-table>
  <table
    class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl text-nowrap">
    <thead>
    <tr>
      <th>Nome</th>
      <th>CNPJ</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let e of enquadradaModel">
      <td>{{e.nome}}</td>
      <td>{{formatCnpj(e.cnpj)}}</td>
    </tr>
    </tbody>
  </table>
  <div class="row">
    <div class="col-xs-12 col-12">
      <div class="d-flex justify-content-center mb-5">
        <maps-pagination [items]="paginationTotalPage" [pageNumber]="page$"
                         *ngIf="paginationTotalPage && paginationTotalPage > 0"
                         (pageSend)="receiverPage($event)"></maps-pagination>

        <span *ngIf="loading$ | async" class="text-center text-muted label-maps mb-5">Carregando ...</span>
      </div>
    </div>
  </div>
</div>
